import sort, { ESortOrder, stringSort } from "@domains/utils/sort";
export const applyInsiderSorting = (data, sortingType, insiderData) => {
    data.data = insiderData;
    let insiderDetails;
    if (sortingType.sortName == "clientName" ||
        sortingType.sortName == "discriptionName") {
        insiderDetails = stringSort(data.data, sortingType.sortName, sortingType.order);
    }
    else {
        insiderDetails = sort(data.data, sortingType.sortName, sortingType.order);
    }
    data.data = insiderDetails;
    data.sortState.map((e) => (Object.assign(Object.assign({}, e), { order: sortingType.sortName === e.sortName
            ? sortingType.order
            : ESortOrder.UNCHANGED })));
    return data;
};
